export default {
  full_menu: 'Menu complet',
  free: 'GRATUIT',
};
